import Debug from 'debug';
import { LitElement, html, nothing, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { extractTextFromScripts } from '../utils';
import { sqliteBroker } from '../services/SqliteBroker';
import { center, col, grow, row } from '../styles';

import { query, state } from 'lit/decorators.js';
import { tableBroker } from '../services/TableBroker';
import { dataBroker } from '../services/DataBroker';
import { PdqTextEditor } from '../text-editor/pdq-text-editor';

const log = Debug('pdq:sqlite:console');
@customElement('pdq-sqlite-console')
export class PdqSqliteConsole extends LitElement {
  static styles = [col, row, center, grow, css`
  :host{
      display: block;
      height: 100%;
  }
  `];
  static __nextId = 0;
  @state() id = PdqSqliteConsole.__nextId++;
  @property({ type: String }) title: string = 'Sqlite Console';
  @property({ type: String }) database: undefined|string;
  @query('pdq-text-editor') monaco: undefined|PdqTextEditor

  @state() _height = 500;
  protected resizeObserver: ResizeObserver|undefined;
  @state() error: string = '';
  @state() queryTime: string = '';

  render() {
    return html`
      <div class="col">
        ${this.title ? html`<div style="background-color: #5e5e5e; padding: 8px">${this.title}</div>` : nothing }
        <pdq-text-editor language="sql" height="calc( ${this._height/2}px - 20px )"></pdq-text-editor>
        <div class="row">
          <cds-button @click=${this.execute} size="xs">Execute</cds-button>
          <div class="center" style="color: red; margin: 0 8px">${this.error}</div>
          <div class="grow"></div>
          <div class="center" style="color: gray; margin: 0 8px">${this.queryTime}</div>
        </div>
        <pdq-perspective-viewer ?hidden=${this.error||this.first} table="sqlite-console-table-${this.id}" height="calc(${this._height/2}px - 40px )" editable></pdq-perspective-viewer>
      </div>
      <slot style="display: none" name="query" @slotchange="${this._onSlotChange}"></slot>
    `;
  }
  first = true
  async execute() {
    log(`execute`);
    this.error = ''
    this.queryTime = ''
    if(!this.monaco) {
      this.error = `monaco element not found...`
      log(`monaco element not found...`);
      return
    }
    if (!this.database) {
      this.error = `database is not set...`
      log(`database is not set...`);
      return
    }

    await sqliteBroker.getDatabaseReadyPromise(this.database)

    const ds = `sqlite-console-table-${this.id}-ds`
    const table = `sqlite-console-table-${this.id}`;
    tableBroker.clearTable(table)
    const start = performance.now()
    try {
      const sql = this.monaco.editor?.getModel()?.getValueInRange(
        this.monaco.editor?.getSelection() ?? { startLineNumber: 1, startColumn: 1, endLineNumber: Infinity, endColumn: Infinity }
      ) || this.monaco.editor?.getValue() || '';

      if (!sql) {
        log(`sql is not truthy...`);
        return
      }
      const client = await sqliteBroker.getDatabaseClient(this.database!);
      const data = await client.query(sql)

      await dataBroker.setDataSource(ds, data)
      if (this.first)
      {
        const t = await tableBroker.setTable(table, ds)
        t.subscribe(async i => {

          log('TABLE !!!!!', await i.schema(),  i, t);
        });
        this.first = false;
      }
      this.queryTime = `${performance.now() - start} ms`
      log(`query success ${performance.now() - start} ms`)
    } catch (e:any) {
      this.error = 'error' in e ? e.error : JSON.stringify(e)
      this.queryTime = `${performance.now() - start} ms`
    }
  }
  protected async _onSlotChange(event: Event) {
    if (!this.database) {
      log(`WARNING: database is not set, statement cannot be applied`)
      return
    }
    try {
      const slot = event.target as HTMLSlotElement
      const nodes = slot.assignedNodes({ flatten: true })
      const statement = extractTextFromScripts(nodes)
      this.monaco?.editor?.setValue(statement)
      await this.execute()
    } catch (e) {
      console.error(`Failed to parse statement`, e);
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this._height = entry.contentRect.height;
        console.log('this.height', this._height);
        this.requestUpdate();
      }
    });
    this.resizeObserver.observe(this as any);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
  }
}